import React from "react";
import { MapPin } from "lucide-react";
import SettingsListPanel from "./SettingsListPanel";

// The timezone here is what the missing-time-log reminder uses to work out when
// it is 8am for everyone at this location. Left blank, the location inherits
// the org timezone from Company Information.
const WorkLocationsManagement = () => (
  <SettingsListPanel
    config={{
      title: "Work Locations",
      subtitle: "Manage employee work locations",
      icon: MapPin,
      endpoint: "/api/settings/work-locations",
      itemLabel: "Work Location",
      columnLabel: "Name",
      placeholder: "Enter work location name",
      extraField: {
        key: "timezone",
        label: "Timezone",
        placeholder: "Asia/Kolkata",
        hint: "IANA timezone name. Reminders for people at this location are timed against it. Leave blank to use the company timezone.",
        width: 200,
      },
    }}
  />
);

export default WorkLocationsManagement;
